/*
 * Copyright (C) 2019 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { NgModule } from '@angular/core';
import { environment } from 'environments/environment';
import { StoreModule, Action } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { reducer, SharedDataEffects, SharedDataState, INITIAL_STATE } from './store';
import { SharedDataService } from './services/shared-data.service';
import { MockSharedDataService } from './services/mock-shared-data.service';
import { ApiSharedDataService } from './services/api-shared-data.service';
import { RestClientService } from 'app/shared/services/rest-client.service';
import { flattenReducers } from 'app/shared/store/utils';

@NgModule({
  declarations: [],
  imports: [
    StoreModule.forFeature('shared-data', sharedDataReducer),
    EffectsModule.forFeature([SharedDataEffects])
  ],
  providers: [
    { provide: SharedDataService, useFactory: sharedDataServiceFactory, deps: [RestClientService] }
  ]
})
export class SharedDataModule {}

/** The flattened reducer for the Shared Data state. */
export function sharedDataReducer(state: SharedDataState, action: Action): SharedDataState {
  return flattenReducers(INITIAL_STATE, reducer)(state, action);
}

// -------------------------------------------------------------------------
/** Provides the shared data service. */
export function sharedDataServiceFactory(restClientService: RestClientService): SharedDataService {
  if (environment.dataProvider === 'mock') {
    return new MockSharedDataService();
  }
  return new ApiSharedDataService(restClientService);
}
